module.exports = __webpack_public_path__ + "static/media/bg37.7fe2e983.jpg";